module.exports = __webpack_public_path__ + "static/media/library-smart.f3499973.svg";